import React from 'react';
import { styled } from '@mui/material';

import { Card, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const GroupCard = ({ group, members, onClick, ...rest }) => {
    return (
        <Card {...rest} onClick={onClick}>
            <CustomStack spacing={2}>
                <Text align={'left'} variant={'sh2'} weight={'semibold'}>
                    {members.length === 1 ? getUserPreferredFullName(members[0]) : group.name}
                </Text>
                <Text align={'left'} color={'light'} variant={'p2'} weight={'semibold'}>
                    Members ({members.length})
                </Text>
                <Stack
                    sx={{ flexWrap: 'wrap' }}
                    direction={'row'}
                    divider={
                        <Text color={'disabled'} variant={'p2'}>
                            /
                        </Text>
                    }
                    spacing={1}
                >
                    {members.map((member) => (
                        <Text key={member.owner_account_id} color={'light'} variant={'p2'}>
                            {getUserPreferredFullName(member)}
                        </Text>
                    ))}
                </Stack>
            </CustomStack>
        </Card>
    );
};

const CustomStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

export default GroupCard;
